import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Following: {
    defaultMessage: 'Following',
    description: 'Button on an artist card to unfollow an artist.'
  },
  Follow: {
    defaultMessage: 'Follow',
    description: 'Button on an artist card to follow an artist.'
  }
});

export default messages;
